import React, { useEffect, useRef, useState } from 'react'
import { url } from '../../../../configlink';
import axios from '../../../../api/axios';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';



export default function DiscountDetail() {

    let [discountData, setDiscountData] = useState({
        code: '',
        type: '',
        value: '',
        upto: 0,
        fromDate: '',
        toDate: '',
        category: '',
        orgs: '',
        users: '',
    })

    let adminUser = useSelector((state) => state.userAdmin.userAdmin)

    let [showSpecificCorp, setShowSpecificCorp] = useState(false)

    console.log(discountData);

    let [companyData, setCompanyData] = useState([])

    useEffect(() => {
        getCompanyDrpDown()
    }, [])

    let loc = useLocation()
    let id = loc.search.split('=')[1]

    let [editMode, setEditMode] = useState(false)
      
      useEffect(() => {
        if(id){
            setEditMode(true)
          getData(id)
        }
      }, []);

      function getData(x){
          console.log(x);
          try {
            fetch(`${url}/api/admin/get_discounts?id=${x}`, {
              credentials: 'include',
              headers: {
                    'acgt-admin': adminUser
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    console.log("fetched", data); 

                    let data2 = data.data[0] 

                    if(data2.discount_org){
                        let d2 = JSON.parse(data2.discount_org).orgs

                        // console.log('d2', d2);
                        setDiscountData({
                            code: data2.discount_code,
                            type: data2.discount_type.toString(),
                            value: data2.discount_value,
                            upto: Number(data2.discount_upto),
                            fromDate: data2.fromDate.split('T')[0],
                            toDate: data2.toDate.split('T')[0],
                            category: 'orgs',
                            orgs: d2
                        })
                    } 
                    else if(data2.discount_user){
                        let d3 = JSON.parse(data2.discount_user).users

                        // console.log('d3', d3);
                        setDiscountData({
                            code: data2.discount_code,
                            type: data2.discount_type.toString(),
                            value: data2.discount_value,
                            upto: Number(data2.discount_upto),
                            fromDate: data2.fromDate.split('T')[0],
                            toDate: data2.toDate.split('T')[0],
                            category: 'users',
                            users: d3
                        })
                    }

                })
                .catch(err => {
                    console.error(err);  
                })
        } catch (error) {
            console.error(error);
            
        }
        }


    const getCompanyDrpDown = async () => {
        try {
          const response = await axios.get(
            `${url}/api/admin/get_corporate_lists`, {
              withCredentials: true,
              headers: {
                    'acgt-admin': adminUser
                },
            }
          );
    
        //   console.log(response.data);

        let sortedData = response.data.sort((a,b) => {
            if (a.CorporateName.toLowerCase() < b.CorporateName.toLowerCase()) return -1; 
            if (a.CorporateName.toLowerCase() > b.CorporateName.toLowerCase()) return 1;  
            return 0; 
        })
        // console.log("sorted",sortedData);
    
          setCompanyData(sortedData);
        } catch (error) {
          console.error(error);
        }
      };




        let [errors, setErrors] = useState({})

    function validateData(){
        const discountErrors = {};
            if (!discountData.code) discountErrors.code = "Please Enter";
            if (!discountData.type) discountErrors.type = "Please Select";
			if (!discountData.value) discountErrors.value = "Please Enter";
			if (Number(discountData.upto) < 0) discountErrors.upto = "Value must be >= 0";
            if (!discountData.fromDate) discountErrors.fromDate = "Please Enter";
            if (!discountData.toDate) discountErrors.toDate = "Please Enter";
            if (!discountData.category) discountErrors.category = "Please Select"

            if(discountData.category === 'orgs' && !discountData.orgs) discountErrors.orgs = 'Please add'
            if(discountData.category === 'users' && !discountData.users) discountErrors.users = 'Please add'

            return discountErrors
    }   
    
    function submitDiscountData(){
        const validate = validateData()

        console.log(validate);
    
        if (Object.keys(validate).length > 0) {
            setErrors(validate);
        } else {
            console.log('pass');

            let data = discountData
   
            console.log('pass2', data);

            try {
                fetch(`${url}/api/admin/create_discount`, {
                    method:"POST",
                    credentials: 'include',
                    headers:{
                    'Content-Type':'application/json',
                    'acgt-admin': adminUser
                    },
                    body: JSON.stringify(data)
                })
                .then(res => res.json())
                .then(data => {
                    if(data.message === 'success'){
                        console.log('success');
                        alert("Success")
                        setDiscountData({
                            code: '',
                            type: '',
                            value: '',
                            upto: 0,
                            fromDate: '',
                            toDate: '',
                            category: '',
                            orgs: '',
                            users: '',
                        })   
                        window.close()             
                    }
                })
                .catch(err => {
                    console.error(err)
                }) 
                
                } catch (error) {
                console.error(error);
                } 
    
        }
    }

    function editDiscountData(){
        const validate = validateData()

        console.log(validate);
    
        if (Object.keys(validate).length > 0) {
            setErrors(validate);
        } else {
            console.log('pass');

            let data = discountData            
            
            // console.log('pass2', data);

            try {
                fetch(`${url}/api/admin/edit_discount?id=${id}`, {
                    method:"PUT",
                    credentials: 'include',
                    headers:{
                    'Content-Type':'application/json',
                    'acgt-admin': adminUser
                    },
                    body: JSON.stringify(data)
                })
                .then(res => res.json())
                .then(data => {
                    if(data.message === 'success'){
                        console.log('success');
                        alert("Success")              
                    }
                })
                .catch(err => {
                    console.error(err)
                }) 
                
                } catch (error) {
                console.error(error);
                } 
    
        }
    }

    let [searchedUsers, setSearchedUsers] = useState([])

    console.log(searchedUsers);
    

    function searchForUser(x){
        try {
            fetch(`${url}/api/admin/searchForUser?val=${x}`, {
                 credentials: 'include',
                 headers: {
                    'acgt-admin': adminUser
                },   
            })
            .then((res) => res.json())
            .then(data => {
                if(data.message==='success'){
                    console.log(data.data);
                    setSearchedUsers(data.data)
                }
                else {
                    alert("No users found.")
                }
            })
        } catch (error) {
            console.log(error);
            
        }

    }
    

  return (
    <div  className='w-full p-8'>
    
        <div className='w-full'>
            <p className='text-2xl text-[var(---color-primary-purple)]'>Discount Details</p>
            <div className='mt-2 border-1 border-black px-4 py-4'>
                <div className='flex flex-col gap-[20px] pb-20 gap-[40px]'>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>Code:</label>
                        <div className='flex-1 flex flex-col'>
                            <input 
                                type="text" 
                                name="code" 
                                placeholder='Enter code' 
                                value={discountData.code}
                                className='border-1 h-[35px] px-2'
                                onChange={(e) => {
                                    setErrors({...errors, code:''})
                                    setDiscountData({...discountData, code: e.target.value})}
                                } 
                            />
                            {errors.code && 
                            <span className='text-[14px] text-red-500 font-bold'>{errors.code}</span>
                            }
                        </div>
                    
                    </div>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>Type:</label>
                        <div className='flex-1 flex flex-col '>
                            <div className="flex items-center gap-[30px]">
                                <div className='flex items-center gap-[10px]'>
                                    <input 
                                        type="radio" 
                                        name="type" 
                                        className='w-[20px] h-[20px]' 
                                        checked={discountData.type === '1'}
                                        onChange={() => {
                                            setErrors({...errors, type:''})
                                            setDiscountData({...discountData, type: '1', upto:0})

                                        }
                                        } 
                                    />
                                    <label>Dollar Value</label>
                                </div>
                                <div className='flex items-center gap-[10px]'>
                                    <input 
                                        type="radio" 
                                        name="type" 
                                        className='w-[20px] h-[20px]' 
                                        checked={discountData.type === '2'}
                                        onChange={() => {
                                            setErrors({...errors, type:''})
                                            setDiscountData({...discountData, type: '2'})
                                        }
                                        } 
                                    />
                                    <label>Percentage</label>
                                </div>
                                {discountData.type === '1' && <p>$</p>}
                                <div className="flex flex-col justify-start">
                                    <input 
                                        type="text" 
                                        name="value"
                                        placeholder='Enter Value' 
                                        value={discountData.value}
                                        className='border-1 h-[35px] px-2'
                                        onChange={(e) => {
                                            setErrors({...errors, value:''})
                                            setDiscountData({...discountData, value: e.target.value})}
                                        } 
                                    />
                                    
                                </div>
                                {discountData.type === '2' && <p>%</p>}
                            </div>
                            <div className='flex'>
                                {errors.type && 
                                    <span className='text-[14px] text-red-500 font-bold'>{errors.type}</span>
                                }
                                {errors.value && 
                                            <span className='text-[14px] text-red-500 font-bold ml-20'>{errors.value}</span>
                                        }
                            </div>
                        </div>
                    </div>
                    {discountData.type === '2' && 
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>Up to:</label>
                        <div className='flex-1 flex flex-col '>
                            <div className="flex items-center gap-[30px]">
                                <p>$</p>
                                <div className="flex flex-col justify-start">
                                    <input 
                                        type="number" 
                                        name="value"
                                        placeholder='Enter Value' 
                                        value={discountData.upto}
                                        className='border-1 h-[35px] px-2'
                                        onChange={(e) => {
                                            setErrors({...errors, upto:''})
                                            setDiscountData({...discountData, upto: e.target.value})}
                                        } 
                                    />
                                </div>
                                <p>(Optional)</p>
							</div>
							<p className='text-sm mt-2 text-blue-500'>NOTE: If you want 20% on entire order amount with no upper limit, &apos;Up to&apos; value = 0</p>
                            {errors.upto && 
                                <span className='text-[14px] text-red-500 font-bold ml-20'>{errors.upto}</span>
                            }
                        </div>
                    </div>
                    }
                    <div className='flex items-start gap-[10px]'>
                        <label className='w-[150px] text-xl'>Apply to:</label>
                        <div className="flex flex-col gap-[10px] flex-1">
                            <div className='flex items-center gap-[50px]'>
                                <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="radio" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={discountData.category === 'orgs'}
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setDiscountData({...discountData, category: 'orgs', users: ''})
                                        setSearchedUsers([])
                                    }
                                    } 
                                />
                                <label>Organizations</label>
                            </div>
                            <div className='flex items-center gap-[10px]'>
                                <input 
                                    type="radio" 
                                    name="category" 
                                    className='w-[20px] h-[20px]' 
                                    checked={discountData.category === 'users'}
                                    onChange={() => {
                                        setErrors({...errors, category:''})
                                        setDiscountData({...discountData, category: 'users', orgs: ''})}
                                    } 
                                />
                                <label>Users</label>
                            </div>
                            </div>
                            {errors.category && 
                                <span className='text-[14px] text-red-500 font-bold ml-20'>{errors.category}</span>
                            }
                            {discountData.category === 'orgs' && 
                                <>
                                    <div className='flex flex-col'>
                                        <div className='flex items-center gap-[10px]'>
                                            <select 
                                                name="specificCorp"
                                                className='w-[300px] h-[35px] border-1'
                                                id='tmpCorp'
                                            >
                                            {companyData.map((data, i) => (
                                                <option value={JSON.stringify({id: data.CorporateId, name: data.CorporateName})} key={i}>
                                                    {data.CorporateName}
                                                </option>
                                                ))}
                                            </select>
                                            <button 
                                            className='bg-[var(--color-primary-purple)] text-white px-2 py-1 rounded-md'
                                            onClick={() => { 
                                                let val = document.getElementById('tmpCorp').value
                                                console.log(val);
                                                setErrors({...errors, category:'', orgs:''})
                                                setDiscountData({
                                                    ...discountData,
                                                    orgs: [...discountData.orgs, JSON.parse(val)]
                                                });
                                                
                                                document.getElementById('tmpCorp').value = ''
                                            }}
                                            >Add</button>
                                        </div>
                                        <div className=' mt-2 flex gap-[20px] flex-wrap'>
                                            {discountData.orgs && discountData.orgs.length > 0 && discountData.orgs.map((item, index) => (
                                                <button 
                                                key={index} 
                                                className='bg-gray-200 px-2 text-sm rounded-md'
                                                onClick={() => {
                                                    setDiscountData({
                                                        ...discountData,
                                                        orgs: discountData.orgs.filter(x => x.id !== item.id)
                                                    })}
                                                }
                                                >
                                                    {item.name} <span className='text-red-500 text-sm ml-1'>✖</span>
                                            </button>
                                        
                                            ))}
                                            {errors.orgs && 
                                                <span className='text-[14px] text-red-500 font-bold ml-20'>{errors.orgs}</span>
                                            }
                                        </div>
                                    </div>
                                </>
                            } 

                            {discountData.category === 'users' && 
                                <>
                                    <div className='flex flex-col'>
                                        <div className='flex items-center gap-[10px]'>
                                            <input 
                                            type="text" 
                                            id='tmpSearch'
                                            className='px-2 w-[350px] h-[35px] border-1'
                                            placeholder='Enter atleast 4 characters'
                                            />
                                            <button 
                                            className='bg-[var(--color-primary-purple)] text-white px-2 py-1 rounded-md'
                                            onClick={() => { 
                                                let val = document.getElementById('tmpSearch').value
                                                console.log(val, val.length);
                                                if(val.length > 3){
                                                    console.log('pass');
                                                    searchForUser(val)
                                                }
                                                else {
                                                    alert("Please type atleast 4 characters")
                                                }
                                               
                                            }}
                                            >Search</button>
                                        </div>
                                            {searchedUsers && searchedUsers.length > 0 && 
                                                <div className='border-1 border-black w-[450px] mt-2 flex flex-col h-[150px] overflow-y-auto'>
                                                        {searchedUsers.map((item,index) => (
                                                        <div key={index} className=' p-1 w-full border-1 flex justify-between items-center'>
                                                            <p>{item.name}</p>
                                                            <button
                                                            className='bg-gray-500 text-white px-2 py-1 rounded-md'
                                                            onClick={() => {
                                                                 let val = item
                                                                console.log(val);

                                                                setErrors({...errors, category:'', users:''})
                    
                                                                setDiscountData({
                                                                    ...discountData,
                                                                    users: [...discountData.users, val]
                                                                });
                                                                
                                                                let filtUser = searchedUsers.filter(x => x.name.toLowerCase() !== val.name.toLowerCase())
                                                                setSearchedUsers(filtUser)
                                                                
                                                            }}
                                                            >Select</button>
                                                        </div>
                                                        ))
                                                        }
                                                </div>
                                            }
                                        <div className=' mt-2 flex gap-[10px] flex-wrap'>
                                            {discountData.users && discountData.users.length > 0 && discountData.users.map((item, index) => (
                                                <button 
                                                key={index} 
                                                className='bg-gray-200 px-2 text-sm rounded-md'
                                                onClick={() => {
                                                    setDiscountData({
                                                        ...discountData,
                                                        users: discountData.users.filter(x => x.userId !== item.userId)
                                                    })                                            
                                                    
                                                    // console.log("itemCLicked", item);

                                                    let addBack = searchedUsers
                                                    addBack.push(item)
                                                    
                                                    setSearchedUsers(addBack)
                                                }
                                                }
                                                >
                                                    {item.name} <span className='text-red-500 text-sm ml-1'>✖</span>
                                            </button>
                                            ))}
                                            {errors.users && 
                                                <span className='text-[14px] text-red-500 font-bold ml-20'>{errors.users}</span>
                                            }
                                        </div>
                                    </div>
                                </>
                            } 

                            {errors.category && 
                                <span className='text-[14px] text-red-500 font-bold'>{errors.title}</span>
                            }
                        </div>
                    </div>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>From:</label>
                        <div className='flex flex-col'>
                            <input 
                                type="date" 
                                name="fromDate" 
                                value={discountData.fromDate}
                                className='w-[200px] border-1 h-[35px] px-2'
                                onChange={(e) => {
                                    setErrors({...errors, fromDate:''})
                                    setDiscountData({...discountData, fromDate: e.target.value})}
                                } 
                            />
                             {errors.fromDate && 
                                <span className='text-[14px] text-red-500 font-bold'>{errors.fromDate}</span>
                            }   
                        </div>
                    </div>
                    <div className='flex items-start gap-[10px] '>
                        <label className='w-[150px] text-xl'>To:</label>
                        <div className='flex flex-col'>
                            <input 
                                type="date" 
                                name="toDate" 
                                value={discountData.toDate}
                                className='w-[200px] border-1 h-[35px] px-2'
                                onChange={(e) => {
                                    setErrors({...errors, toDate:''})
                                    setDiscountData({...discountData, toDate: e.target.value})}
                                } 
                            />
                            {errors.toDate && 
                                <span className='text-[14px] text-red-500 font-bold'>{errors.toDate}</span>
                            }  
                        </div>
                    </div>

                    {editMode ?
                    <button onClick={editDiscountData} className='px-4 py-2 bg-[var(--color-primary-purple)] text-white font-bold w-fit self-center'>Edit</button>
                    :
                    <button onClick={submitDiscountData} className='px-4 py-2 bg-[var(--color-primary-purple)] text-white font-bold w-fit self-center'>Submit</button>
                    
                    }
                </div>
            </div>
        </div>
    </div>
  )
}
